export default "__VITE_ASSET__1dacad73__"